/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";

import {useDispatch} from "react-redux";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import ApplicationApiContext from "@Contexts/Api";


import {Redirect} from "react-router-dom";

import {Button, Col, Row} from "react-bootstrap";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";


import MonitoryNoteDispositionsComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Dispositions";
import MonitoryNoteCompartmentsComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Compartments";


import MonitoryNoteScheduleWindowComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/ScheduleWindow";
import scrollToDomElement from "@Utilities/Animations/Scrolling";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";

import MonitoryNoteInformationComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/NoteInformation";
import VEHICLE_INTERFACE from "@Services/Application/Interfaces/Vehicles/Vehicle";
import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";
import DISPOSITION_INTERFACE from "@Services/Application/Interfaces/Dispositions/Disposition";
import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";
import MonitoryNotePictureComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Picture";
import COMPARTMENT_INTERFACE from "@Services/Application/Interfaces/Vehicles/Compartment";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import {CHANGE_API_REQUEST_TOKEN} from "@Actions/Api";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";
import ContentInformationComponent from "@Components/UI/Content/Information";
import CHANGE_MODAL_MESSAGE_ACTION from "@Actions/Interface/ChangeModalMessage";
import MainContentLoaderComponent from "@Components/UI/Loaders/MainContent";
import RestApiRequestLoaderComponent from "@Components/UI/Loaders/ApiRequest";


export interface MONITORY_NOTE_DATA_INTERFACE {
    DISPOSITIONS?: string[];
    TERMINAL?: {TERMINAL_NAME?: string; TERMINAL_ID?: string}
    VEHICLES?: {FRONT?: VEHICLE_INTERFACE; REAR?: VEHICLE_INTERFACE};
}


type CreateMonitoryNotePageProps = {location: any};


export const CreateMonitoryNotePageComponent: React.FC<CreateMonitoryNotePageProps> = ({
    location
}): JSX.Element | null => {


    const DISPATCHER = useDispatch();


    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    /** @const {boolean} REST_API_REQUEST_STATUS - Application Global State Rest Api Request Status */
    const REST_API_REQUEST_STATUS: boolean = INTERFACE_DATA?.apiRequestStatus || false;


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const MONITORY_NOTE_DATA: MONITORY_NOTE_DATA_INTERFACE = location?.state;


    const {
        DISPOSITIONS, TERMINAL, VEHICLES
    } = MONITORY_NOTE_DATA;


    const [MONITORY_NOTE_SUBMIT_SUCCESS, SET_MONITORY_SUBMIT_SUCCESS] = useState<boolean>(false);


    const MONITORY_NOTE_DEFAULTS: MONITORY_NOTE_INTERFACE = {
        UserId: LOGGED_USER?.userID,
        TerminalNo: TERMINAL?.TERMINAL_ID || null,
        ScheduleId: null,
        FrontTruckRegNo: VEHICLES?.FRONT?.RegNo || null,
        RearTruckRegNo: VEHICLES?.REAR?.RegNo || null,
        IsBooked: false,
        IsDetailed: false,
        Disps: [],
        Compartments: [],
        CompartmentsList: {},
        Products: null,
        ProductsList: {}
    };

    const [MONITORY_NOTE_LOADED_STATUS, SET_MONITORY_NOTE_LOADED_STATUS] = useState<boolean>(false);

    const [MONITORY_NOTE, SET_MONITORY_NOTE] = useState<MONITORY_NOTE_INTERFACE | null>(MONITORY_NOTE_DEFAULTS);
    const [MONITORY_NOTE_ERROR, SET_MONITORY_NOTE_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    const [MONITORY_NOTE_IS_DETAILED_STATUS, SET_MONITORY_NOTE_IS_DETAILED_STATUS] = useState<boolean>(true);

    const [SCHEDULE_WINDOW_LOADED_STATUS, SET_SCHEDULE_WINDOW_LOADED_STATUS] = useState<boolean>(false);

    const [COMPONENT_SCROLL_HANDLER, SET_COMPONENT_SCROLL_HANDLER] = useState<boolean>(false);

    useEffect(() => {
        if (COMPONENT_REF && COMPONENT_REF?.current) {
            scrollToDomElement(COMPONENT_REF, 100);
        }
    }, []);


    useEffect(() => {
        if (COMPONENT_SCROLL_HANDLER) {
            scrollToDomElement(COMPONENT_REF, 100);
            SET_COMPONENT_SCROLL_HANDLER(false);
        }
    }, [COMPONENT_SCROLL_HANDLER]);


    useEffect(() => {
        return () => {SET_MONITORY_NOTE(MONITORY_NOTE_DEFAULTS);};
    }, []);



    useEffect(() => {

        if (!REST_API_URL || !LOGGED_USER.userID) return;

        if (!DISPOSITIONS || !DISPOSITIONS.length) SET_MONITORY_NOTE_ERROR({ErrorCode: 400, UserMessage: "Nie wybrano Dyspozycji"});
        if (!TERMINAL?.TERMINAL_ID) SET_MONITORY_NOTE_ERROR({ErrorCode: 400, UserMessage: "Nie wybrano Bazy Paliw"});
        if (!VEHICLES?.FRONT?.RegNo && !VEHICLES?.REAR?.RegNo) SET_MONITORY_NOTE_ERROR({ErrorCode: 400, UserMessage: "Nie wybrano Pojazdów"});

        const GET_SELECTED_DISPOSITIONS = async (): Promise<any> => {

            const DISPOSITION_API_URL: string = REST_API_URL + "/Disp/Get";

            const DISPOSITION_LIST: DISPOSITION_INTERFACE[] = [];

            if (DISPOSITIONS) {

                let TOKEN: AUTHORIZATION_TOKEN_INTERFACE | null = Object.assign({}, REST_API_REQUEST_TOKEN);

                for (let DISPOSITION of DISPOSITIONS) {

                    try {

                        const DISPOSITION_REQUEST_DATA = {
                            UserId: LOGGED_USER?.userID,
                            DispNo: DISPOSITION
                        };

                        const DISPOSITION_RESPONSE = await REST_API_REQUEST(
                            DISPOSITION_API_URL,
                            DISPOSITION_REQUEST_DATA,
                            TOKEN
                        );

                        if (DISPOSITION_RESPONSE.status !== 200) continue;

                        const DISPOSITION_RESPONSE_CONTENT: DISPOSITION_INTERFACE = await DISPOSITION_RESPONSE.json();

                        TOKEN = prepareRestApiRequestToken(DISPOSITION_RESPONSE.headers);

                        DISPOSITION_LIST.push(DISPOSITION_RESPONSE_CONTENT)

                    } catch (e) {
                        continue
                    }

                }

                await DISPATCHER(CHANGE_API_REQUEST_TOKEN_ACTION(TOKEN));

            }

            SET_MONITORY_NOTE({...MONITORY_NOTE, Disps: DISPOSITION_LIST});

        };

        GET_SELECTED_DISPOSITIONS();

    }, [REST_API_URL, DISPOSITIONS]);


    useEffect(() => {

        const COMPARTMENTS: any = {};

        if (VEHICLES?.FRONT?.IsTank && VEHICLES?.FRONT?.Compartments) {
            for (let compartment of VEHICLES?.FRONT?.Compartments) {
                COMPARTMENTS[`F${compartment.CompPos}`] = {
                    product: null,
                    capacity: compartment.MaxVol,
                    DefaultVol: compartment.DefaultVol,
                    productCompartments: {},
                    compartmentVehicle: "F",
                    compartmentPosition: `F${compartment.CompPos}`
                };
            }
        }

        if (VEHICLES?.REAR?.IsTank && VEHICLES?.REAR?.Compartments) {
            for (let compartment of VEHICLES?.REAR?.Compartments) {
                COMPARTMENTS[`R${compartment.CompPos}`] = {
                    product: null,
                    capacity: compartment.MaxVol,
                    DefaultVol: compartment.DefaultVol,
                    productCompartments: {},
                    compartmentVehicle: "R",
                    compartmentPosition: `R${compartment.CompPos}`
                };
            }
        }


        const Products: any = {};

        if (MONITORY_NOTE?.Disps) {
            for (let disposition of MONITORY_NOTE?.Disps) {
                if (!disposition?.DispItems) continue;
                for (let product of disposition?.DispItems) {
                    const productID: string = disposition.DispNo + (product?.ProductMasterNo || product?.ProductShortName || "") + product.Pos;
                    Products[productID] = {...product, DispNo: disposition?.DispNo, productCompartments: {}};
                }
            }
        }

        SET_MONITORY_NOTE({...MONITORY_NOTE, ProductsList: Products, CompartmentsList: COMPARTMENTS});

    }, [MONITORY_NOTE?.FrontTruckRegNo, MONITORY_NOTE?.RearTruckRegNo, MONITORY_NOTE?.Disps]);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={"/404"} />;


    const MODIFY_COMPARTMENT_HANDLER = (compartmentID: any, compartmentProductId: any, compartmentProductCapacity: number, compartmentProductReceiver: string) => {

        const selectedCompartment = MONITORY_NOTE?.CompartmentsList[compartmentID];
        const selectedProduct = MONITORY_NOTE?.ProductsList[compartmentProductId];

        if (!selectedProduct) return;

        selectedCompartment.product = selectedProduct;
        selectedCompartment.productCapacity = compartmentProductCapacity || 0;

        selectedProduct.productCompartments[compartmentID] = compartmentProductCapacity;
        if (compartmentProductReceiver) selectedProduct.ReceiverMasterNo = compartmentProductReceiver;

        SET_MONITORY_NOTE({
            ...MONITORY_NOTE,
            ProductsList: {...MONITORY_NOTE?.ProductsList, [compartmentProductId]: selectedProduct},
            CompartmentsList: {...MONITORY_NOTE?.CompartmentsList, [compartmentID]: selectedCompartment}
        });

    };


    const CLEAR_COMPARTMENT_HANDLER = (compartmentID: any, compartmentProductId: any) => {

        const selectedCompartment = MONITORY_NOTE?.CompartmentsList[compartmentID];
        const selectedProduct = MONITORY_NOTE?.ProductsList[compartmentProductId];

        selectedCompartment.product = null;
        delete selectedProduct?.productCompartments[compartmentID];

        // SET_MONITORY_NOTE({
        //     ...MONITORY_NOTE,
        //     ProductsList: {...MONITORY_NOTE?.ProductsList, [compartmentProductId]: selectedProduct},
        //     CompartmentsList: {...MONITORY_NOTE?.CompartmentsList, [compartmentID]: selectedCompartment}
        // });

        SET_MONITORY_NOTE({
            ...MONITORY_NOTE,
            ProductsList: {...MONITORY_NOTE?.ProductsList, [compartmentProductId]: selectedProduct},
        });

    };


    const MONITORY_NOTE_CREATE_SUBMIT_HANDLER = async (): Promise<void> => {

        const selectedCompartments: any = MONITORY_NOTE?.CompartmentsList ? Object.values(MONITORY_NOTE?.CompartmentsList).filter(
            (compartment: any) => !!compartment?.product
        ) : null;

        const requestCompartments: COMPARTMENT_INTERFACE[] = [];

        if (selectedCompartments && MONITORY_NOTE_IS_DETAILED_STATUS) {

            const DISPOSITION_PRODUCTS: any = {};

            if (MONITORY_NOTE?.Disps) {
                for (let disposition of MONITORY_NOTE.Disps) {
                    if (disposition.DispItems) {
                        for (let product of disposition.DispItems) {
                            if (product.ProductMasterNo) {
                                DISPOSITION_PRODUCTS[product.ProductMasterNo] = disposition.DispNo;
                            }
                        }
                    }
                }
            }

            for (let compartment of selectedCompartments) {

                const {
                    compartmentPosition, compartmentVehicle,
                    product, productCapacity
                } = compartment;

                if (!product || !compartmentVehicle) continue;

                if (+productCapacity < 500) continue;

                let compartmentVehicleRegNo: string = "";
                if (compartmentVehicle === "F") compartmentVehicleRegNo = MONITORY_NOTE?.FrontTruckRegNo || "";
                if (compartmentVehicle === "R") compartmentVehicleRegNo = MONITORY_NOTE?.RearTruckRegNo || "";

                requestCompartments.push({
                    Pos: +compartmentPosition[1], TruckRegNo: compartmentVehicleRegNo,
                    DispNo: product.DispNo, DispPos: product.Pos,
                    Qty: +productCapacity,
                    ReceiverMasterNo: product.ReceiverMasterNo
                });

            }

        }

        if (MONITORY_NOTE_IS_DETAILED_STATUS && requestCompartments.length < 1) {
            SET_MONITORY_NOTE_ERROR({ErrorCode: 1, UserMessage: "Jeśli plan załadunku jest aktywny, przynajmniej jedna komora powinna zawierać w pełni skonfiigurowany produkt"})
            SET_COMPONENT_SCROLL_HANDLER(true);
            return;
        }

        const REQUEST_BODY: any = {
            UserId: LOGGED_USER?.userID,
            TerminalNo: TERMINAL?.TERMINAL_ID,
            FrontTruckRegNo: MONITORY_NOTE?.FrontTruckRegNo || null,
            RearTruckRegNo: MONITORY_NOTE?.RearTruckRegNo || null,
            Compartments: requestCompartments,
            Disps: MONITORY_NOTE?.Disps,
            ScheduleId: MONITORY_NOTE?.ScheduleId || null,
            IsBooked: !!MONITORY_NOTE?.ScheduleId,
            IsDetailed: !!requestCompartments?.length
        };

        await MONITORY_NOTE_CREATE_REQUEST_HANDLER(REQUEST_BODY);

    };


    const MONITORY_NOTE_CREATE_REQUEST_HANDLER = async (REQUEST_BODY: any) => {

        try {

            const MONITORY_NOTE_API_URL: string = REST_API_URL + "/TransportNotification";

            const MONITORY_NOTE_RESPONSE = await REST_API_REQUEST(
                MONITORY_NOTE_API_URL,
                REQUEST_BODY,
                REST_API_REQUEST_TOKEN
            );

            if (MONITORY_NOTE_RESPONSE.status === 204) {

                SET_MONITORY_NOTE(MONITORY_NOTE_DEFAULTS);
                SET_MONITORY_SUBMIT_SUCCESS(true);

            } else {
                const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await MONITORY_NOTE_RESPONSE.json();
                SET_MONITORY_NOTE_ERROR({UserMessage: CONTENT?.UserMessage, ErrorCode: MONITORY_NOTE_RESPONSE.status});
                SET_COMPONENT_SCROLL_HANDLER(true);
            }

        } catch (e) {
            SET_MONITORY_NOTE_ERROR({UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK", ErrorCode: 500});
            SET_COMPONENT_SCROLL_HANDLER(true);
        }

    };


    if (MONITORY_NOTE_SUBMIT_SUCCESS === true) {
        return <Redirect to={"/"} />;
    }


    if (!MONITORY_NOTE?.Disps) return <Redirect to={"dyspozycje"} />;


    if (!MONITORY_NOTE?.Disps?.length) return <ContentInformationComponent contentMessage={`Nie wybrano Dyspozycji`} />;


    const LOADED = !!MONITORY_NOTE && !!VEHICLES && !!MONITORY_NOTE?.CompartmentsList && !!MONITORY_NOTE?.ProductsList && MONITORY_NOTE_IS_DETAILED_STATUS !== null;


    if (!LOADED) return null;


    const removeDispositionHandler = (disposition: DISPOSITION_INTERFACE, remove = true) => {

        if (!MONITORY_NOTE?.Disps) return;

        if (!remove) {
            SET_MONITORY_NOTE({...MONITORY_NOTE, Disps: [...MONITORY_NOTE.Disps, disposition]});
            return;
        }

        if (MONITORY_NOTE?.Disps.length < 2) {
            DISPATCHER(CHANGE_MODAL_MESSAGE_ACTION(
                "Nie można usunąć dyspozycji - awizacja musi posiadać przynajmniej jedną dyspozycję.",
            ));
            return;
        }

        const removeDisposition = () => {
            if (!MONITORY_NOTE?.Disps) return;
            const updatedDispositions = MONITORY_NOTE.Disps.filter((disp) => disp.DispNo !== disposition.DispNo);
            SET_MONITORY_NOTE({...MONITORY_NOTE, Disps: updatedDispositions});
            DISPATCHER(CHANGE_MODAL_MESSAGE_ACTION(null));
        };

        DISPATCHER(CHANGE_MODAL_MESSAGE_ACTION(
            "Anulowanie dyspozycji spowoduje usunięcie pozycji planu załadunku związanego z tą dyspozycją. Czy chcesz kontynuować ? ",
            "DEFAULT",
            removeDisposition,
            () => {}
        ));

    };


    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"create-monitory-note-page-component monitory-note-page-component"}>

            <BlockContentHeaderComponent headerText={"Awizacja"} />

            {!!MONITORY_NOTE_ERROR && <ErrorMessageComponent messageText={MONITORY_NOTE_ERROR.UserMessage} />}

            {!MONITORY_NOTE_LOADED_STATUS && !REST_API_REQUEST_STATUS && <RestApiRequestLoaderComponent />}

            {!!MONITORY_NOTE &&
	        <MonitoryNoteInformationComponent
		        MONITORY_NOTE_PROCESS_TYPE={"creation"}
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_HANDLER={SET_MONITORY_NOTE}
		        MONITORY_NOTE_DATA={MONITORY_NOTE_DATA}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
	        />
            }

            {!!MONITORY_NOTE && SCHEDULE_WINDOW_LOADED_STATUS &&
	        <MonitoryNoteDispositionsComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_PROCESS_TYPE={"create"}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
		        LOAD_CONTENT_HANDLER={SET_MONITORY_NOTE_LOADED_STATUS}
		        removeDispositionsHandler={removeDispositionHandler}
	        />
            }

            {!!MONITORY_NOTE &&
	        <MonitoryNoteScheduleWindowComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_HANDLER={SET_MONITORY_NOTE}
		        MONITORY_NOTE_ACTION_TYPE={"creation"}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
		        SCHEDULE_WINDOW_LOADED_STATUS_HANDLER={SET_SCHEDULE_WINDOW_LOADED_STATUS}
	        />
            }

            {!!MONITORY_NOTE &&
	        <MonitoryNoteCompartmentsComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_ACTION_TYPE={"creation"}
		        MONITORY_NOTE_DETAILED_STATUS={MONITORY_NOTE_IS_DETAILED_STATUS}
		        MONITORY_NOTE_DETAILED_STATUS_HANDLER={SET_MONITORY_NOTE_IS_DETAILED_STATUS}
		        compartmentModifyHandler={MODIFY_COMPARTMENT_HANDLER}
		        compartmentClearHandler={CLEAR_COMPARTMENT_HANDLER}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
	        />
            }

            <>
                {!!MONITORY_NOTE_LOADED_STATUS && (MONITORY_NOTE.ProcessStartDate == undefined || MONITORY_NOTE.ProcessStartDate == '0' || MONITORY_NOTE.IsBooked) &&
		        <Col xs={12} className={"monitory-note-submit"} onClick={() => MONITORY_NOTE_CREATE_SUBMIT_HANDLER()}>
			        <Button variant={"primary"}>
				        <span>{`Utwórz awizację`}</span>
			        </Button>
		        </Col>
                }
            </>


        </BlockContentContainerComponent>
    );

};


export default CreateMonitoryNotePageComponent;
